import React, { useState, useEffect } from "react";

//
import { Row, Button, Card } from "react-bootstrap";

//
import { getCategories, getNews } from "../../redux/features/coins/actions";

//
import NewsItem from "../../components/news/NewsItem";
import FirstNews from "../../components/news/FirstNews";
import PageHeader from "../../components/general/PageHeader";
import BoxLoading from "../../components/general/BoxLoading";
import FilterDropdown from "../../components/general/FilterDropdown";
import NothingToShow from "../../components/general/NothingToShow";

function News() {
  const [loading, setLoading] = useState(false);
  const [limit, setLimit] = useState(7);
  //
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState({});
  const [news, setNews] = useState([]);

  /**
   * Get Categories
   */
  const get_categories = async () => {
    // start loading
    setLoading(true);

    // request
    await getCategories().then((res) => {
      if (res) {
        setCategories(res.category);
        setSelectedCategory(res.category[0]);
      }
    });

    // stop loading
    setLoading(false);
  };

  /**
   * Get News List
   */
  const get_news = async () => {
    if (selectedCategory.value) {
      // start loading
      setLoading(true);

      // set variable
      let category = selectedCategory.value;

      // request
      await getNews(category).then((res) => {
        if (res) {
          setNews(res);
        }
      });

      // stop loading
      setLoading(false);
    }
  };

  useEffect(() => {
    get_categories();

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    get_news();
  }, [selectedCategory]);

  return (
    <div id="news">
      {/* Start Header */}
      <PageHeader title="News" subject="Crypto details overview and analytics">
        <FilterDropdown
          filters={categories}
          activeFilter={selectedCategory}
          action={(item) => setSelectedCategory(item)}
          title="Type"
          fit
        />
      </PageHeader>
      {/* End Header */}

      {loading && <BoxLoading />}

      {news.length ? (
        <>
          <FirstNews item={news[0]} />

          <Row>
            {news.slice(1, limit).map((item, index) => (
              <NewsItem item={item} key={index} />
            ))}
          </Row>

          {limit < news.length && (
            <Button
              variant="white"
              size="lg"
              className="d-block m-auto see-more"
              onClick={() => setLimit(limit + 6)}
            >
              See other blogs
            </Button>
          )}
        </>
      ) : (
        <Card>
          <NothingToShow text={loading ? "Loading..." : "No news to show"} />
        </Card>
      )}
    </div>
  );
}

export default News;
